import styled from "styled-components";

export const PaymentInstallmentWrapper = styled.div`
	width: 100%;
	display: flex;
	justify-content: space-between;
	align-items: end;
	margin-top: 15px;
`;

export const PaymentInstallmentCheckbox = styled.div`
	width: fit-content;
`;
export const PaymentInstallmentSelection = styled.div`
`;

export const PaymentInstallmentLeft = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
	width: 45%;

	@media only screen and (max-width: 600px) {
		width: 72%;
	}
`

export const PaymentInstallmentAmount = styled.div`
    color: var(--font-color-blue5b7792);
    margin-bottom: 12px;
		margin: 0;
		margin-bottom: 12px;
`;
